import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from 'material-ui-icons/Close';
import { investmentStatuses } from 'entoro-shared';

const getStatusColor = (value) => {
  if (value === 'Not Started') {
    return 'gray';
  } else if (value === 'Investment Complete') {
    return 'green';
  }

  return 'orange';
};

const FormHeader = ({
  disabled,
  name,
  investmentStatus,
  handleClose,
  toggleCancelDialog,
}) => (
  <div className='stepper--header'>
    <button onClick={handleClose} className='stepper--header__close--button'>
      <CloseIcon />
    </button>
    <h1 className='stepper--header__title'>You are investing in {name}</h1>
    <p className='stepper--header__status'>
      Investment Status:{' '}
      <span
        className={`stepper--header__status__${getStatusColor(
          investmentStatuses.getLabel(investmentStatus)
        )}`}
      >
        {investmentStatuses.getLabel(investmentStatus)}
      </span>
    </p>
    {!disabled && (
      <button
        className='stepper--header__cancel--button'
        onClick={toggleCancelDialog}
      >
        Cancel Transaction
      </button>
    )}
  </div>
);

FormHeader.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  investmentStatus: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  toggleCancelDialog: PropTypes.func.isRequired,
};

FormHeader.defaultProps = {
  disabled: false,
};

export default FormHeader;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/FormHeader.js